const showAristocracyEffect = (data) => new Promise((res) => {
  window.HiyaJSBridge.callHandler("showAristocracyEffect", data, ({ status }) => {
    res(status);
  });
});
export {
  showAristocracyEffect
};
